<template>
  <nav ref="navEl" class="lg:grid lg:grid-cols-3 lg:gap-x-16 xl:gap-x-28">
    <ul class="common-class text-[1.875rem] bg-primary col-span-3 lg:col-span-1 font-serif font-bold text-white">
      <AppMenuItem
        v-for="item in mainNavigation"
        :key="item.id"
        :item="item"
        @click="handleFirstItemClick"
        :force-unclick="forceUnclickNested[0] || selectedItem[0]?.id !== item.id"
      />
    </ul>
    <ul class="common-class hidden lg:block text-lg">
      <AppMenuItem
        v-if="selectedItem.at(0)"
        v-for="item in selectedItem[0].items"
        :key="item.id"
        :item="item"
        class="animate__animated animate__faster"
        :class="{ animate__fadeInRight: selectedItem[0] }"
        :force-unclick="forceUnclickNested[1] || selectedItem[1]?.id !== item.id"
        @click="handleSecondItemClick"
        nested-menu
      />
    </ul>
    <ul class="common-class hidden lg:block text-lg">
      <AppMenuItem
        v-if="selectedItem.at(1)"
        v-for="item in selectedItem[1].items"
        :key="item.id"
        :item="item"
        class="animate__animated animate__faster"
        :class="{ animate__fadeInRight: selectedItem[1] }"
        nested-menu
      />
    </ul>
    <div v-if="selectedItem.length" class="absolute left-0 top-0 lg:hidden px-6 pt-6">
      <UtilityButton is-button class="bg-secondary !p-4" @click="handleNavigation">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 text-primary">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>

        <span class="sr-only">Go to upper menu level button</span>
      </UtilityButton>
    </div>
  </nav>
</template>
<script setup lang="ts">
import 'animate.css'

const mainNavigation = useMainNavigation()
const selectedItem = ref<any>([])
const navEl = ref<HTMLElement>()
const forceUnclickNested = ref([false, false])
const handleFirstItemClick = (item: any, isArrowClicked: boolean = false) => {
  if (item) {
    navEl.value?.children[0].classList.add('hidden', 'lg:block')
    navEl.value?.children[1].classList.replace('hidden', 'block')
    selectedItem.value = [item]
  } else {
    navEl.value?.children[0].classList.remove('hidden', 'lg:block')
    navEl.value?.children[1].classList.replace('block', 'hidden')
    selectedItem.value = []
  }

  if (isArrowClicked) {
    navEl.value?.children[0].classList.add('animate__animated', 'animate__faster', 'animate__fadeInRight')
    setTimeout(() => {
      navEl.value?.children[0].classList.remove('animate__animated', 'animate__faster', 'animate__fadeInRight')
    }, 500)
  }
}

const handleSecondItemClick = (item: any) => {
  if (item) {
    navEl.value?.children[1].classList.replace('block', 'hidden')
    navEl.value?.children[2].classList.replace('hidden', 'block')
    selectedItem.value = [selectedItem.value[0], item]
  } else {
    navEl.value?.children[1].classList.replace('hidden', 'block')
    navEl.value?.children[2].classList.replace('block', 'hidden')
    selectedItem.value = [selectedItem.value[0]]
  }
}

const handleNavigation = () => {
  if (selectedItem.value.length === 2) {
    forceUnclickNested.value[1] = true
    handleSecondItemClick(null)
  } else if (selectedItem.value.length === 1) {
    forceUnclickNested.value[0] = true
    handleFirstItemClick(null, true)
  } else {
    return
  }
}

watch(
  () => forceUnclickNested.value,
  (val) => {
    if (val.some((item) => item)) {
      setTimeout(() => {
        val.fill(false)
      }, 10)
    }
  },
  { deep: true },
)
</script>

<style scoped>
@reference "~/assets/css/main.css";

.common-class {
  @apply py-20 lg:py-28 h-full overflow-auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
